export enum Banners {
  tracking = 'BANNER_TRACKING',
  initial = 'BANNER_TRACKING_INITIAL',
}
